import React from 'react';
import { ExportCheckboxGroupWrapper } from '../styled';
import { Checkbox, Divider } from 'antd';

export const ExportCheckbox = (props: {
  title: string;
  checked: boolean;
  onChange: (b: boolean) => void;
}) => {
  const { title, checked, onChange } = props;
  const handleClick = () => {
    onChange(!checked);
  };
  return (
    <ExportCheckboxGroupWrapper>
      <Checkbox checked={checked} onClick={handleClick}>
        {title}
      </Checkbox>
      <Divider style={{ margin: '8px 0' }} />
    </ExportCheckboxGroupWrapper>
  );
};
